import React from "react";
import { Instagram, Youtube, Mail } from "lucide-react";
import { contactData, socialLinks } from "@/data/mock";

const FlickrIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <circle cx="7" cy="12" r="5.5" fill="#0063DC" />
    <circle cx="17" cy="12" r="5.5" fill="#FF0084" />
  </svg>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1A1A1A] py-8 sm:py-12 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col items-center gap-5 sm:gap-6 md:flex-row md:justify-between">
          <a
            href="#"
            onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="font-bebas text-xl tracking-[0.15em] text-white"
          >
            ANKIT MOHANTY
          </a>
          <div className="flex items-center gap-5">
            <a
              href={socialLinks.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center text-white/30 hover:text-[#C4956A] hover:border-[#C4956A]/50 transition-all duration-300"
              aria-label="Instagram"
            >
              <Instagram size={16} />
            </a>
            <a
              href={socialLinks.youtube}
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center text-white/30 hover:text-[#C4956A] hover:border-[#C4956A]/50 transition-all duration-300"
              aria-label="YouTube"
            >
              <Youtube size={16} />
            </a>
            <a
              href={socialLinks.flickr}
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center text-white/30 hover:text-[#C4956A] hover:border-[#C4956A]/50 transition-all duration-300"
              aria-label="Flickr"
            >
              <FlickrIcon size={13} />
            </a>
            <a
              href={`mailto:${socialLinks.email}`}
              className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center text-white/30 hover:text-[#C4956A] hover:border-[#C4956A]/50 transition-all duration-300"
              aria-label="Email"
            >
              <Mail size={16} />
            </a>
          </div>
          <p className="font-inter text-xs text-white/20 tracking-wide">
            &copy; {currentYear} Ankit Mohanty. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
